<div [ngClass]="inline ? 'inline-panel' : 'panel'">
  <h2 *ngIf="!inline">Champs supplémentaires</h2>

  <ng-container *ngFor="let field of fields">
    <div class="form-group">
      <label for="field.keys[0]">{{ field.label }}</label>

      <t-select *ngIf="field.input === 'list'" [items]="field.values" [(item)]="field.model.value"></t-select>

      <input *ngIf="field.input === 'text'" type="text" [(ngModel)]="field.model.value" [readonly]="field.readonly" />

      <span class="info info-right">
        <ng-container *ngFor="let key of field.fullKeys">
          &nbsp;&nbsp;&nbsp;&nbsp; {{ key }}
        </ng-container>
      </span>
    </div>
  </ng-container>
  
</div>